import ajax from "./ajax";
import {
	AUTH_BASE_URL,
	AUTH_REDIRECT_URI,
	AUTH_CLIENT_ID,
	AUTH_SCOPE,
} from "@/lib/constants/auth.constants";
import type { TAjaxHeaders, TAjaxOptions } from "@/types";

const authApi = {
	getCognitoToken,
	getCognitoUserInfo,
};

export default authApi;

export async function getCognitoToken({
	urlCode,
	refreshToken,
	redirectUri = AUTH_REDIRECT_URI!,
}: {
	urlCode: string;
	refreshToken: string;
	redirectUri?: string;
}) {
	const headers: TAjaxHeaders = {
		"Content-Type": "application/x-www-form-urlencoded",
		Accept: "application/json",
		"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
		"Access-Control-Allow-Headers": "Content-Type, Authorization",
		"Access-Control-Allow-Credentials": "true",
		"Access-Control-Max-Age": "86400",
		"Access-Control-Expose-Headers": "Location",
		"Access-Control-Request-Headers": "Content-Type, Authorization",
		"Access-Control-Request-Method": "GET, POST, PUT, DELETE, OPTIONS",
		"Access-Control-Request-Credentials": "true",
		"Access-Control-Request-Max-Age": "86400",
		"Access-Control-Request-Expose-Headers": "Location",
		"keep-alive": "true",
		"cache-control": "no-cache",
	};

	const payload: Record<string, string> = {
		code: urlCode || refreshToken,
		scope: AUTH_SCOPE!,
		redirect_uri: redirectUri,
		grant_type: refreshToken ? "refresh_token" : "authorization_code",
		client_id: AUTH_CLIENT_ID!,
		...(refreshToken !== "" && { refresh_token: refreshToken }),
	};

	const url = `${AUTH_BASE_URL}/oauth2/token?${new URLSearchParams(payload).toString()}`;

	return ajax.post(url, payload, {
		headers,
		credentials: "include",
		mode: "cors",
		referrerPolicy: "no-referrer",
		keepalive: true,
		cache: "no-cache",
	} as TAjaxOptions);
}

export async function getCognitoUserInfo(token: string) {
	const headers: TAjaxHeaders = {
		Authorization: `Bearer ${token}`,
	};

	return ajax.get(`${AUTH_BASE_URL}/oauth2/userInfo`, { headers });
}
